import React from 'react';
import {
  Edit,
  TabbedForm,
  TextInput,
  required,
  ReferenceManyField,
  Datagrid,
  TextField,
  ReferenceField,
  DeleteButton, FormTab,
} from 'react-admin';
import CreateRelatedButton from '../components/CreateRelatedButton';

const GrupoReglaEdit = (props) => (
  <Edit mutationMode="optimistic" {...props}>
    <TabbedForm>
      <FormTab label="resources.grupo-regla.tabs.general">
        <TextInput source="descripcion" validate={[required()]} />
      </FormTab>
      <FormTab label="resources.grupo-regla.tabs.prestaciones">
        <CreateRelatedButton
            reference="prestacion-grupo-regla"
            refFieldName="idGrupoRegla"
            source="id"
            label="resources.grupo-regla.buttons.agregarPrestacion"
        />
        <ReferenceManyField
          addLabel={false}
          reference="prestacion-grupo-regla"
          source="id"
          target="idGrupoRegla"
          sort={{ field: "idPrestacion", order: "DESC" }}
          filter={{ deleted: false }}
        >
          <Datagrid rowClick={null}>
            <TextField source="idPrestacion" label="resources.grupo-regla.fields.id"/>
            <ReferenceField
              label="resources.grupo-regla.fields.descripcion"
              source="idPrestacion"
              reference="prestaciones"
              link={false}
            >
              <TextField source="descripcion" />
            </ReferenceField>
            <DeleteButton mutationMode="optimistic" redirect={false} />
          </Datagrid>
        </ReferenceManyField>
      </FormTab>
    </TabbedForm>
  </Edit>
);

export default GrupoReglaEdit;
